module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"title","time":"Start time - End time","time_spent":"Time Spent"},"th":{"title":"งาน","time":"วันที่เริ่ม - สิ้นสุด","time_spent":"เวลาที่ใช้ไป"}}')
  delete Component.options._Ctor
}
